const formatter = (
  locale: string,
  currency: string,
  config: Intl.NumberFormatOptions = {},
) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    ...config,
  })

const USDFormatter = formatter('en-US', 'USD')

const USDFormatterRound = formatter('en-US', 'USD', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
})

// Rounds and truncates amounts like 34.00 to $34 but formats amounts
// like 34.78 to $34.78
const USDFormatterAutoRound = (amount: number) => {
  const isInteger = Number.isInteger(amount)

  return isInteger
    ? USDFormatterRound.format(amount)
    : USDFormatter.format(amount)
}

const FormatWithUnitPostfix = (amount: number) => {
  const isTrillion = amount >= 1.0e12
  const isBillion = amount >= 1.0e9
  const isMillion = amount >= 1.0e6
  const isThousand = amount >= 1.0e3

  // Checking less than 15 zeros
  switch (Math.abs(Number(amount)) < 1.0e15) {
    case isTrillion:
      return (amount / 1.0e12).toFixed(2) + 'T'
    case isBillion:
      return (amount / 1.0e9).toFixed(2) + 'B'
    case isMillion:
      return (amount / 1.0e6).toFixed(2) + 'M'
    case isThousand:
      return (amount / 1.0e3).toFixed(2) + 'K'
    default:
      return amount.toString()
  }
}

export {
  formatter,
  FormatWithUnitPostfix,
  USDFormatter,
  USDFormatterAutoRound,
  USDFormatterRound,
}
